import main from './main/index.js';
import games from './main/games.js';

let routerArr = main.concat(main,games);

export default routerArr



// WEBPACK FOOTER //
// ./src/router/main.js